import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { pingServer } from "../lib/api";

// Tiny global "Reconnecting…" strip. Shows whenever the server becomes
// unreachable (a network/timeout error fires ss:network-down), quietly polls
// for recovery, and clears itself + fires ss:network-up the moment it's back,
// so a brief cold-start blip is reassuring rather than a scary dead-end.
export const ConnectionBanner = () => {
  const [down, setDown] = useState(false);

  useEffect(() => {
    let poll = null;
    const stop = () => { if (poll) { clearInterval(poll); poll = null; } };
    const startPolling = () => {
      if (poll) return;
      poll = setInterval(async () => {
        if (await pingServer()) {
          stop();
          setDown(false);
          try { window.dispatchEvent(new CustomEvent("ss:network-up")); } catch {}
        }
      }, 3000);
    };
    const onDown = () => { setDown(true); startPolling(); };
    window.addEventListener("ss:network-down", onDown);
    return () => { window.removeEventListener("ss:network-down", onDown); stop(); };
  }, []);

  if (!down) return null;

  return (
    <div
      data-testid="reconnecting-banner"
      className="fixed top-0 inset-x-0 z-[110] bg-[#0F0F0F] border-b border-[#14A89A]/40 text-[#14A89A] px-4 py-2 flex items-center justify-center gap-2 font-body text-xs tracking-wide"
    >
      <Loader2 size={13} className="animate-spin" />
      <span>Reconnecting…</span>
    </div>
  );
};
